import IconHandset from '@/shared/icons/NewDesign/IconHandset'
import { ContactLastname, ContactName, EmptyValue, PhoneLink, SecondaryLine } from '../../styled-components'

interface ContactCellProps {
  hasContact: boolean
  emptyLabel: string
  lastname: string
  firstname: string
  email: string
  phone: string
  zohoLink: string
  zohoLinkLabel: string
}

const ContactCell = ({
  hasContact,
  emptyLabel,
  lastname,
  firstname,
  email,
  phone,
  zohoLink,
  zohoLinkLabel,
}: ContactCellProps) => {
  if (!hasContact) return <EmptyValue>{emptyLabel}</EmptyValue>

  return (
    <>
      <ContactName>
        <ContactLastname>{lastname}</ContactLastname> {firstname}
      </ContactName>
      <SecondaryLine hidden={!email}>{email}</SecondaryLine>
      <PhoneLink $hidden={!phone} href={zohoLink} target='_blank' rel='noreferrer' title={zohoLinkLabel}>
        <IconHandset size={15} />
        {phone}
      </PhoneLink>
    </>
  )
}

export default ContactCell
